import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: false,
    edgeService: 'https://api.pma-apc.ceres.siemens.cloud',
    // AppSync Events URLs
    appSyncRealtimeUrl: 'wss://appsync.api.pma-apc.ceres.siemens.cloud/event/realtime',
    appSyncHttpUrl: 'https://appsync.api.pma-apc.ceres.siemens.cloud/event',
    scdUrl: 'https://api.scd.suites.siemens.cloud',
    siteCollection: '/test/10000120',
    languageAssetsPath: './assets/language/',
    tracking: false,
    whitelist: ['api.pma-apc.ceres.siemens.cloud'],
    apiKey: 'u1nS4XFFDs8SOS9AF3gmB1rpQbkQzdkBayVVxhkF',
    tenant: 'DI FA PMA APC',
    guestAccess: false,
    links: {
        documentOfferTemplate: '',
        documentOfferTemplateEN: ''
    },
    junoApp: 'https://juno.suites.siemens.cloud',
    junoApiURI: 'https://api.mail.wcs-apps.siemens.cloud/v2.0',
    junoAppId: '73a1c4a89ae54505824b6f0f4fcc78b3',
    commentRequiredThreshold: 10,
    timeSheetSumRowFloatingPoints: '1.1-1',
    timeSheetRounding: true,
    servicesDocumentationLink: '',
    msalConfig: {
        auth: {
            clientId: '58fbc816-7562-49a8-a5d8-11959aea263e', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['User.ReadBasic.All', 'User.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.pma-apc.ceres.siemens.cloud/App.Access.All'],
            uri: 'https://api.pma-apc.ceres.siemens.cloud/'
        }
    ]
};
